export default __webpack_public_path__ + "static/Winner seal__NSW_Broker of the Year-38a3e709f1e2eb74594aa8e5ff9a1118.png";